import uniqid from 'uniqid'
import { useCallback, useEffect } from 'react'

import { PlainRadioGroup, PlainRadioGroupProps } from 'app/common/ui-next/plain-radio-button'
import { DataBox, useDataBoxSelector, useDataBoxStatus } from 'app/common/data-box-store'

type ItemProps = { id: string; title: string; disabled?: boolean; level?: number }

type Props = {
  dataBoxData?: DataBox<Array<ItemProps>>
  dataBoxSelection?: DataBox<string>
  resetOnDismount?: boolean
} & Omit<PlainRadioGroupProps, 'onChange' | 'items' | 'current'>

export const PlainRadioGroupBox = ({
  id,
  label,
  disabled,
  dataBoxData = new DataBox<Array<ItemProps>>(uniqid('empty-data-'), []),
  dataBoxSelection = new DataBox<string>(uniqid('empty-selection-'), ''),
  resetOnDismount,
}: Props) => {
  const items = useDataBoxSelector(dataBoxData, () => dataBoxData.data)
  const current = useDataBoxSelector(dataBoxSelection, () => dataBoxSelection.data)
  const ready = useDataBoxStatus(dataBoxData, () => dataBoxData.ready)

  const handleChange = useCallback((value: string) => {
    dataBoxSelection.updateData(() => value)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      if (resetOnDismount) {
        dataBoxData.reset()
        dataBoxSelection.reset()
      }
    }
  }, [resetOnDismount]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PlainRadioGroup
      id={id}
      label={label}
      items={items}
      current={current}
      disabled={disabled || !ready}
      onChange={handleChange}
      keepPadding
    />
  )
}
